import React from 'react';
import routes from 'sitewide-js/core_pre_webpack/routes';
import styled from 'astroturf/react';
import InfoIcon from 'js/design_system/icons/info.svg';
import { Banner } from 'js/design_system/Banner';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import _ExploreButton from "ExploreConversations-ExploreButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/ExploreConversations.tsx?styleId=ExploreButton";


const ExploreButton = /*#__PURE__*/styled(ButtonLink, null, {
  displayName: "ExploreButton",
  styles: _ExploreButton
});

interface Props {
  displayName: string;
}

export const ExploreConversations = (props: Props) => {
  return (
    <Banner icon={<InfoIcon />}>
      <Body>
        {props.displayName} hasn't posted lately. See what your network is
        talking about.
      </Body>
      <ExploreButton inverse href={routes.home_url()}>
        Explore conversations
      </ExploreButton>
    </Banner>
  );
};
